import styled from 'styled-components';

export const Document = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	background-color: #F5F5F5;
	align-items: center;
	padding: 16px;
	height: calc(100vh - 140px);

	@media only screen and (max-width: 599px) {
		background-color: #FFF;
	}
`;

Document.Card = styled.div`
	background-color: #FFF;
	border-radius: 16px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	max-width: 800px;
	overflow: auto;

	@media only screen and (max-width: 599px) {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		padding: 24px;
	}
`;

Document.HeaderTitle = styled.p`
	font-family: 'Inter', sans-serif;
	font-size: 20px;
	font-weight: 700;
	color: #14191E;
	line-height: 28px;
	margin-bottom: 8px;
`;

Document.HeaderSubtitle = styled.p`
	font-size: 14px;
	color: #26282A;
	font-weight: 400;
	line-height: 1.5;

	strong {
		font-weight: 600;
	}
`;

Document.TextContainer = styled.div`
	border: 1px solid #E5E5E5;
	border-radius: 12px;
	height: calc(100vh - 412px);
	overflow-y: auto;

	@media only screen and (max-width: 599px) {
		height: 500px;
	}
`;

Document.TextContent = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 1.6;
	color: #26282A;
	white-space: pre-wrap;
	word-wrap: break-word;
`;

Document.SignatureBox = styled.div`
	border: 2px dashed #D9E1E8;
	border-radius: 12px;
	height: 80px;
	transition: border-color 0.2s, background-color 0.2s;
	background-color: #F0F2F5;
	overflow: hidden;

	&:hover {
		border-color: #5B7FFF;
		background-color: #F0F2F5;
	}
`;

Document.SignatureBoxPlaceholder = styled.span`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #767B7F;
`;

Document.SignatureBoxImage = styled.img`
	max-width: 180px;
	max-height: 100%;
	object-fit: contain;
`;

